import { Pipe, PipeTransform } from '@angular/core';

import { Utils } from '@shared/utils/utils';

@Pipe({
  name: 'round',
  standalone: true,
})
export class RoundPipe implements PipeTransform {
  transform(value?: null | number | string | undefined, decimalPlaces?: number): string {
    const roundedNumber = Utils.roundToNumber(value || 0, decimalPlaces || 2);

    if (roundedNumber) {
      return roundedNumber.toString();
    } else if (value) {
      return '0.00';
    }

    return Utils.zeroHyphen;
  }
}
